import axios from "axios";
import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { API_URL } from "./api";


export const useGet = (url, initialState = []) => {
  const [data, setData] = useState(initialState);
  const [token, setToken] = useCookies(["token"]);
  useEffect(() => {
    axios
      .get(API_URL + url, {
        headers: { Authorization: `Bearer ${token.token}` },
      })
      .then((response) => {
        setData(response.data);
      });
  }, [url]);

  return [data];
};

export const useGetPagination = (url, initialState = []) => {
  const [data, setData] = useState(initialState);
  const [token, setToken] = useCookies(["token"]);
  useEffect(() => {
    axios
      .get(url, {
        headers: { Authorization: `Bearer ${token.token}` },
      })
      .then((response) => {
        setData(response.data);
      });
  }, [url]);

  return [data];
};

export const useGetSimple = (slug, initialState = []) => {
  const [data, setData] = useState(initialState);
 
  useEffect(() => {
    axios
      .get(API_URL +'form/'+ slug)
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => {
        setData(error);
      });
  }, [slug]);

  return [data];
};



export default useGet;
